import { ApiSliceParams } from "../interfaces";
import {
    BudgetPhaseCreateRequest,
    BudgetPhaseUpdateRequest,
} from "./interfaces";

export const makePhase = ({ connection, company }: ApiSliceParams) => {
    const create = async (params: BudgetPhaseCreateRequest) => {
        const con = connection.value;

        return await con.budget.phase.create({
            budget: params.budget,
            company: company.value,
            data: {
                prio: params.prio,
                title: params.title,
                description: params.description,
            },
        });
    };

    const update = async (params: BudgetPhaseUpdateRequest) => {
        const con = connection.value;

        if (!con) {
            return;
        }

        await con.budget.phase.update({
            id: params.id,
            company: company.value,
            data: {
                prio: params.prio,
                title: params.title,
                description: params.description,
            },
        });
    };

    return { create, update };
};
